import { ICellRendererParams, type ColDef } from 'ag-grid-community';
import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

export const ALL_ASSESSMENTS_PAGE_SIZE = 25;

export const defaultColDef: ColDef = {
  flex: 1,
};

export const colDefs: ColDef[] = [
  {
    field: 'id',
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value !== undefined) {
        return params.value;
      } else {
        return 'Loading...';
      }
    },
  },
  {
    field: 'createdDate',
    valueFormatter: params => {
      const tzDate = TZDate.tz('Europe/Zurich', params.value);
      return params.value ? format(tzDate, 'yyyy-MM-dd HH:mm:ss') : '';
    },
  },
  {
    field: 'company',
  },
  {
    field: 'industry',
    headerName: 'Sector',
  },
  {
    field: 'country',
  },
  {
    field: 'project',
  },
  {
    field: 'sensitivity',
  },
  {
    field: 'dealId',
  },
  {
    field: 'mainDriver',
  },
  {
    field: 'underwritingSource',
  },
  {
    field: 'createdBy',
  },
];
